import { Skeleton } from "@/components/ui/skeleton";

export function ProcessingSkeleton() {
  return (
    <div className="flex w-full min-w-0 gap-8 overflow-hidden py-4 min-h-[440px] animate-fade-in">
      {/* Left Column: Carousels Skeleton */}
      <div className="flex-1 min-w-0 overflow-hidden border-r border-border pr-6">
        {/* Hazard Analysis Section */}
        <div className="mb-6">
          <Skeleton className="h-4 w-28 mb-3" />
          <div className="min-h-[40px]">
            <div className="flex flex-wrap gap-1.5">
              <Skeleton className="h-6 w-32 rounded-full" />
              <Skeleton className="h-6 w-24 rounded-full" />
              <Skeleton className="h-6 w-28 rounded-full" />
            </div>
          </div>
        </div>

        {/* Regulatory Standards Section */}
        <div className="flex-1 flex flex-col">
          <Skeleton className="h-4 w-48 mb-3" />
          <div className="flex-1 flex flex-col min-h-[200px]">
            <div className="mb-4 pb-4 border-b border-border/30">
              <Skeleton className="h-4 w-32 mb-2" />
              <div className="space-y-1.5 mb-3">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-48" />
                </div>
                <div className="flex items-center gap-2 opacity-50">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-40" />
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-1.5 flex-1" />
                <Skeleton className="h-4 w-10" />
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-2">
              <Skeleton className="h-6 w-36 rounded-full" />
              <Skeleton className="h-6 w-28 rounded-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Right Column: Step List Skeleton */}
      <div className="w-52 flex-shrink-0">
        <div className="space-y-3 mb-6">
          <Skeleton className="h-3 w-16" />
          <div className="space-y-2.5 pl-1">
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-24" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-32" />
            </div>
          </div>
        </div>
        <div className="space-y-3">
          <Skeleton className="h-3 w-20" />
          <div className="space-y-2.5 pl-1">
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-32" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded-full" />
              <Skeleton className="h-4 w-24" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
